var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-card',{attrs:{"flat":""}},[_c('q-card-section',{staticClass:"no-padding"},[_c('div',{staticClass:"font-medium text-grey-14 w-700"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }